<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=550 content-class="round-2xl")
  v-card
    v-card-title.px-4(v-if="title")
      v-spacer
      .text-xl.font-bold {{ title }}
      v-spacer
      v-btn(icon color="neutral700" @click="closeDialog")
        v-icon mdi-close
    v-divider(v-if="title")
    div.py-6.px-10
      slot
    v-divider
    v-card-actions.px-6
      v-btn.button-md.neutral700--text.px-0.underline(text @click="closeDialog") {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(@click="$emit('delete')" :loading="loading" color="danger500" depressed dark) {{ $t('confirm') }}
</template>

<script>

export default {
  name: 'DeleteConfirmationDialog',
  props: {
    open: {
      type: Boolean,
    },
    loading: {
      type: Boolean
    },
    title: {
      type: String,
      default: null
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('cancel')
      this.showDialog = false
    }
  },
}
</script>